import { Box, Card, CardHeader, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, Tooltip } from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import _ from "lodash";
import useOperators from "hooks/useOperators";

const OperatorsComponent = () => {
  const { data, isValidating } = useOperators({ id: "" });
  return (
    <Card sx={{ m: 5 }}>
      <CardHeader title={"OPERATORS"} />
      <PerfectScrollbar>
        <Box sx={{ minWidth: 800 }}>
          {isValidating || data == undefined ? (
            <Box style={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress size="10rem" sx={{ m: 3 }} />
            </Box>
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Operator</TableCell>
                  <TableCell>ApiUrl</TableCell>
                  <TableCell>PrivateKey</TableCell>
                  <TableCell sortDirection="desc">
                    <Tooltip enterDelay={300} title="Sort">
                      <TableSortLabel active direction="desc">
                        Created
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {_.isEmpty(data) == false &&
                  data?.items.map((operator) => (
                    <TableRow hover key={operator.id}>
                      <TableCell>{operator.name}</TableCell>
                      <TableCell>{operator.apiUrl}</TableCell>
                      <TableCell>{operator.privateKey}</TableCell>
                      <TableCell>{operator.created.toString()}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          )}
        </Box>
      </PerfectScrollbar>
    </Card>
  );
};

export default OperatorsComponent;
